import React, { useState, useEffect, useContext, useRef } from "react";
import AppLayout, {
  AppLayoutProps,
} from "@amzn/awsui-components-console/app-layout";
import { NonCancelableCustomEvent } from "@amzn/awsui-components-console";
import { Navigation } from "src/pages/commons";
import { URLS } from "src/components/constants/appConstants";
import { JemGenToolsContent } from "./components/tools-content";
import "../commons/common.styles.scss";
import { appLayoutAriaLabels } from "src/i18n-strings/app-layout";
import { JemGenContent } from "src/components/jemGenPage";
import { InitDomain } from "src/context/domain/domainContext";
import { JemGenSplitPanel } from "./components/split-panel";
import { JemGenContextProvider } from "src/context/jem-gen/JemGenContextProvider";
import { FlareContextProvider } from "src/context/flare/FlareContextProvider";
import { useJemGen } from "src/context/jem-gen/jemGenContext";
import { useSettingsStore } from "src/stores/useSettingsStore";
import { resolveInitialPanelState } from "src/hooks/useInitialPanelState";

function JemGenAppLayout() {
  const { navPanelBehavior, toolsPanelBehavior } = useSettingsStore();
  const [navigationOpen, setNavigationOpen] = React.useState(
    resolveInitialPanelState(false, navPanelBehavior),
  );
  const [toolsOpen, setToolsOpen] = useState(
    resolveInitialPanelState(false, toolsPanelBehavior),
  );
  const [splitPanelOpen, setSplitPanelOpen] = useState(true);
  const { splitPanelSize, setSplitPanelSize } = useJemGen();
  const { domain, setDomain } = useContext(InitDomain);

  useEffect(() => {
    const prevDomain = domain;
    setDomain("Global");
    return () => {
      setDomain(prevDomain);
    };
  }, []);

  const onToolsChangeFn = ({
    detail,
  }: NonCancelableCustomEvent<AppLayoutProps.ChangeDetail>) => {
    setToolsOpen(detail.open);
  };

  return (
    <AppLayout
      content={<JemGenContent />}
      maxContentWidth={Number.MAX_VALUE}
      navigation={<Navigation activeHref={URLS.JEM_GEN} />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      tools={<JemGenToolsContent />}
      toolsOpen={toolsOpen}
      ariaLabels={appLayoutAriaLabels}
      onToolsChange={onToolsChangeFn}
      splitPanelSize={splitPanelSize}
      splitPanelOpen={splitPanelOpen}
      onSplitPanelResize={({ detail }) => setSplitPanelSize(detail.size)}
      onSplitPanelToggle={({ detail }) => setSplitPanelOpen(detail.open)}
      splitPanel={<JemGenSplitPanel setToolsOpen={setToolsOpen} />}
    />
  );
}

export function JemGen() {
  return (
    <FlareContextProvider>
      <JemGenContextProvider>
        <JemGenAppLayout />
      </JemGenContextProvider>
    </FlareContextProvider>
  );
}
